module.exports = __webpack_public_path__ + "img/reportBg.ce36d925.png";